import _ from 'lodash'
import querystring from 'querystring'
import { createAction } from 'redux-actions'
import { actionCreators as api } from 'reduxBits/api'
import { cleanQuery } from 'utils/parameters'

const prefix = 'Toplistings:'

export const REQUEST_TOPLISTINGS = `${prefix} Request toplisting data`
export const RECEIVE_TOPLISTINGS = `${prefix} Receive toplisting data`

const requestToplistings = createAction(REQUEST_TOPLISTINGS)
const receiveToplistings = createAction(RECEIVE_TOPLISTINGS)

const fetchToplistings = (searchQuery) => async (dispatch, getState) => {
  try {
    const state = getState()
    const query = {
      ...{ st: _.get(state, 'searchParams.byQueryKey.st.defaultValue') },
      ...cleanQuery(searchQuery, state),
    }

    dispatch(requestToplistings())

    const response = await dispatch(
      api.fetch(`marketing/v1/toplistings?${querystring.stringify(query)}`),
    )

    if (response.ok) {
      return dispatch(receiveToplistings({ searchQuery, data: response.textOrJson.data }))
    }

    return dispatch(receiveToplistings(response))
  } catch (error) {
    return dispatch(receiveToplistings({ error: true, payload: error }))
  }
}

export const actionCreators = {
  fetchToplistings,
}
